/* eslint max-lines: ["error", { max: 390 }] -- this file contains test IDs for various components */
import { joinTestIDs } from "@/utils/string.util";

const FABTestID = {
  BookAppointment: joinTestIDs("schedule", "empty", "book-appointment"),
  LogOut: "log-out",
  ScheduleEventDetails: "schedule-event-details",
  SearchGroups: "search-groups",
  SelfMonitoring: "self-monitoring",
};

const HomeTestID = {
  EmptyList: joinTestIDs("items", "empty"),
  EmptyUpcomingEvents: joinTestIDs("home", "upcoming-events-empty-card"),
  GreetingCard: joinTestIDs("home", "greeting-card"),
  Primary: "home",
  RecommendedArticle: joinTestIDs("home", "recommended-article"),
  RecommendedFAQ: joinTestIDs("home", "recommended-faq"),
  Tasks: joinTestIDs("home", "tasks"),
  TestimonialImage: joinTestIDs("home", "testimonial-image"),
  UpcomingEventsCard: joinTestIDs("home", "upcoming-events-card"),
  UpcomingEventsHeader: joinTestIDs("home", "upcoming-events-header"),
  UpcomingEventsList: joinTestIDs("home", "upcoming-events-list"),
  WeightTracking: joinTestIDs("home", "weight-tracking"),
};

const NavTestID = {
  BackButton: "back-button",
  Tab: "tab",
  TabSelector: "user-tab-selector",
};

const LoginTestID = {
  Biometrics: "biometrics",
  ClearCache: "clear-cache",
  ClearCacheConfirmation: "clear-cache-confirmation",
  Email: "email",
  ForgotPassword: "forgot-password",
  HelpCenter: "help-center",
  Landing: "landing",
  Login: "login",
  LoginButton: "login-button",
  MFA: "mfa",
  Password: "password",
  RememberMe: "remember-me",
  SplashScreen: "splash-screen",
  Username: "username",
};

// eslint-disable-next-line no-restricted-syntax -- this object is used as a collection of constants rather than as an object directly
const ModalTestID = {
  AboutMessages: "about-messages",
  BookAppointment: "book-appointment",
  ChannelDetails: "channel-details",
  ConfirmGroupRegistration: "confirm-group-registration",
  DownloadEnforcement: "download-enforcement",
  EditAppointment: "edit-appointment",
  EditGroupEvent: "edit-group-event",
  EditGroupRegistration: "edit-group-registration",
  EditNotificationSettings: "edit-notification-settings",
  EditProfile: "edit-profile",
  GroupClassDetails: "group-class-details",
  GroupClassRegistrationModal: "group-class-registration-modal",
  ImageViewer: "image-viewer-modal",
  Modal: "modal",
  ModalBackdrop: "modal-backdrop",
  ModalLayout: "modal-layout",
  SafetyPlanDetails: "safety-plan-details",
  SelfMonitoring: "self-monitoring",
  TitleHeader: "modal-title-header",
  WebBottomSheetContainer: "web-bottom-sheet-container",
  WebRedesignOverview: "web-redesign-overview",
};

const FloatingButtonWrapperTestID = {
  Wrapper: "floating-button-wrapper",
};

// eslint-disable-next-line no-restricted-syntax -- this object is used as a collection of constants rather than as an object directly
const ExploreTestID = {
  Description: joinTestIDs("explore", "header", "description"),
  EmptyGroupClassCard: "empty-group-class-card",
  EmptyList: joinTestIDs("items", "empty"),
  GroupClassCard: "group-class-card",
  GroupClassCardCoreTag: "group-class-card-core-tag",
  GroupClassCardDescription: "group-class-card-description",
  GroupClassCardNextDate: "group-class-card-next-date",
  GroupClassCardOptions: "group-class-card-options",
  GroupClassCardRecurrence: "group-class-card-recurrence",
  GroupClasses: "group-classes",
  GroupClassRegisteredSectionCard: "group-class-registered-section-card",
  GroupClassSeriesCard: "group-class-series-card",
  GroupClassSeriesCarousel: joinTestIDs("explore", "groups-carousel"),
  GroupClassSeriesDetails: "group-class-series-details",
  GroupClassSeriesDetailsCoreTag: "group-class-series-details-core-tag",
  GroupClassSeriesList: "group-class-series-list",
  GroupClassSeriesPreTreatmentDetails:
    "group-class-series-pre-treatment-details",
  GroupClassSeriesPreviewCard: "group-classes-series-preview-card",
  GroupClassSeriesPreviewList: "group-classes-series-preview-list",
  GroupClassSeriesSensitiveDetails: "group-class-series-sensitive-details",
  GroupClassSessionCard: "group-class-session-card",
  GroupClassSessionCardChevron: "group-class-session-card-chevron",
  GroupClassSessionCardHostsAvatarGroup:
    "group-class-session-card-hosts-avatar-group",
  GroupClassSessionCardHostsLabel: "group-class-session-card-hosts-label",
  GroupClassSessionCardOngoingBadge: "group-class-session-card-ongoing-badge",
  GroupClassSessionCardSessionsBadge: "group-class-session-card-sessions-badge",
  GroupClassSessionCardTimeRange: "group-class-session-card-time-range",
  GroupClassSessionList: "group-class-session-list",
  GroupClassSessionListDescription: "group-class-session-list-description",
  GroupClassSessionListTitle: "group-class-session-list-title",
  Groups: "groups",
  Header: joinTestIDs("explore", "header"),
  Illustration: "illustration",
  LoadingState: "loading-state",
  MockCard: "mock-card",
  Primary: "explore",
  RecommendedGroupsBlurb: "recommended-groups-blurb",
  RecurrenceDisplayString: "recurrence-display-string",
  RecurrenceString: "recurrence-string",
  RegisterButton: "register-button",
  Resources: joinTestIDs("explore", "resources"),
  ResourcesCarousel: joinTestIDs("explore", "resources", "carousel"),
  Subtitle: joinTestIDs("explore", "header", "subtitle"),
  TimeRange: "time-range",
  Title: joinTestIDs("explore", "header", "title"),
  WhyAttendGroupsAccordion: "why-attend-groups-accordion",
  WhyCompleteAssessmentsAccordion: "why-complete-assessments-accordion",
  YourGroupsEmptyListCard: "your-groups-empty-list-card",
};

// eslint-disable-next-line no-restricted-syntax -- this object is used as a collection of constants rather than as an object directly
const ProfileTestID = {
  Alert: "profile-alert",
  BasicInfo: "basic-info",
  CalendarPreferencesSection: "calendar-preferences-section",
  ContactInfo: "contact-info",
  ContactSupport: "contact-support",
  EditNotificationSettings: "edit-notification-settings",
  EditProfile: "edit-profile",
  LogOut: "log-out",
  NotificationSettingsOverviewCard: "notification-settings-overview-card",
  NotificationSettingsSection: "notification-settings-section",
  OtherInfo: "other-info",
  Primary: "profile",
  ProviderTeam: "provider-team",
  SafetyPlan: "safety-plan",
  SafetyPlanDetails: "safety-plan-details",
  UserOverview: "user-overview",
};

const LegalLinkTestID = {
  PrivacyPolicy: "privacy-policy",
  TermsOfUse: "terms-of-use",
};

const SafetyPlanTestID = {
  AdditionalInfo: "additional-info",
  ChatSuicideLine: "chat-suicide-line",
  CompletedOn: "completed-on",
  CopingSkills: "coping-skills",
  Hotlines: "hotlines",
  ImminentRiskOfSelfHarm: "risk-of-self-harm",
  LocalEmsPhone: "local-ems-phone",
  MostImportantReasons: "most-important-reasons",
  OtherWarningSigns: "other-warning-signs",
  RiskOfSelfHarm: "risk-of-self-harm",
  SafetyPlanTitle: "safety-plan-title",
  SupportPeople: "support-people",
  TextSuicideLine: "text-suicide-line",
  WarningSigns: "warning-signs",
  WebsiteWithCrisisSkills: "websites-with-crisis-skills",
};

// eslint-disable-next-line no-restricted-syntax -- this object is used as a collection of constants rather than as an object directly
const TextTestID = {
  Avatar: "avatar",
  BoldText: "bold-text",
  BottomSheet: "bottom-sheet",
  Cancel: "cancel",
  Caption: "caption",
  Card: "card",
  Checkbox: "checkbox",
  Comment: "comment",
  Confirm: "confirm",
  Date: "date",
  DatePicker: "date-picker",
  DayOfWeek: "day-of-week",
  Description: "description",
  EmptyList: "empty-list",
  Header: "header",
  Image: "image",
  PressableAvatarCard: "pressable-avatar-card",
  ProgressBar: "progress-bar",
  Subtitle: "subtitle",
  Switch: "switch",
  Tag: "tag",
  Text: "text",
  TextArea: "text-area",
  TextField: "text-field",
  Time: "time",
  Title: "title",
};

const WeightTracking = "weight-tracking";
const WeightTrackingTestID = {
  BriefWeightEntries: joinTestIDs(WeightTracking, "brief-entries"),
  Graph: joinTestIDs(WeightTracking, "graph"),
  Header: WeightTracking,
  History: joinTestIDs(WeightTracking, "history"),
  ListHeader: "list-header",
  NoChange: "no-change",
  NoWeightDataCard: "no-weight-data-card",
  Overview: joinTestIDs(WeightTracking, "overview"),
  Section: joinTestIDs(WeightTracking, "section"),
  WeightUnit: "unit",
  WeightValue: "value",
};

const ScheduleTestID = {
  EmptyList: joinTestIDs("schedule", "empty"),
  GroupEventCoreTag: "group-event-core-tag",
  JoinZoom: "join-zoom",
  PreAdmissionsGroupBlurb: "schedule-pre-admissions-group-blurb",
  Schedule: "schedule",
  ScheduleEventCard: "schedule-event-card",
  ScheduleEventDetails: "schedule-event-details",
  ScheduleEventsList: "schedule-events-list",
};

const MessagesTestID = {
  ChannelList: "channel-list",
};

const ChannelCardTestID = {
  ChannelName: "channel-name",
  EmptyChannel: "empty-channel",
  LastMessage: "last-message",
  LastMessageFile: joinTestIDs("last-message", "file"),
  MentionList: joinTestIDs("chat-channel", "mention-list"),
  ProviderNames: "provider-names",
};

const TasksTestID = {
  InsuranceOverview: "insurance-overview",
  MedicalEvaluationTaskDetails: "medical-evaluation-task-details",
  Primary: "tasks",
  TaskDetails: "task-details",
  TaskOverview: "task-overview",
  TasksEmptyState: "tasks-empty-state",
};

const BookingTestID = {
  AddAttendee: joinTestIDs("add", "optional-attendee"),
  Primary: "booking",
};

const BookingStepTestID = {
  Attendees: "attendees",
  Availability: "availability",
  Confirmation: "confirmation",
  Duration: "duration",
  OptionalAttendees: "optional-attendees",
  Patient: "patient",
  Provider: "provider",
  Recurrence: "recurrence",
  RescheduleScope: "reschedule-scope",
  SessionType: "session-type",
};

const ConfirmationAlertTestID = {
  BookingSuccess: "booking-success",
  CancelAllEvents: "cancel-all-events",
  CancelEvent: "cancel-event",
  CancelLogWeight: "cancel-log-weight",
  CancelUploadInsurance: "cancel-upload-insurance",
  DeclineGroup: "decline-group",
  LeaveBooking: "leave-booking",
  Primary: "confirmation-alert",
  RescheduleAppointment: "reschedule-appointment",
  SkipPushNotification: "skip-push-notification",
  UnregisterGroup: "unregister-group",
};

const OnboardingVerifyInfoTestID = {
  Primary: "onboarding-verify-info",
};

const OnboardingNotificationsTestID = {
  Primary: "onboarding-notifications",
};

const OnboardingWelcomeTestID = {
  Primary: "onboarding-welcome",
};

const OnboardingCalendarSyncTestID = {
  Primary: "onboarding-calendar-sync",
};

const OnboardingConsentTestID = {
  Primary: "onboarding-consent",
};

const OnboardingV2TestID = {
  Content: "onboarding-v2-content",
  Primary: "onboarding-v2",
  Splash: "onboarding-splash",
};

const SMTTestID = {
  AddFood: "add-food",
  AddFoodComment: "food-comment",
  AddFoodDescription: "food-description",
  AddFoodType: "add-food-type",
  AddPhoto: "add-photo",
  AddSMTEntryFlow: "add-entry",
  Primary: "smt",
  SaveEntry: "save-entry",
  SelectPatientModal: "select-patient-modal",
  SMTEntry: "smt-entry",
  SMTSingleDayEntriesAccordion: "smt-single-day-entries-accordion",
  UploadBannerWrapper: "smt-upload-banner-wrapper",
  ViewAllSMTDailyEntriesModal: "smt-view-all-smt-entries-modal",
  WeekLog: "week-log",
  WeekLogSection: "week-log-section",
};

const GroupClassTimeSlotTestID = {
  timeSlotSelector: "time-slot-selector",
  timeSlotTitle: "time-slot-title",
};

// eslint-disable-next-line no-restricted-syntax -- this object is used as a collection of constants rather than as an object directly
const GroupClassRegistrationModalTestID = {
  accordion: "accordion",
  declineReasonForm: "decline-reason-form",
  dismissIcon: "dismiss-icon",
  dismissText: "dismiss-text",
  errorBanner: "error-banner",
  groupCard: "group-card",
  groupCardContent: "group-card-content",
  groupCardCoreTag: "group-card-core-tag",
  groupCardDescription: "group-card-description",
  groupCardDurationBadge: "group-card-duration-badge",
  groupCardDurationText: "group-card-duration-text",
  groupCardTitle: "group-card-title",
  registerButton: "register-button",
  therapistHeader: "therapist-header",
  therapistHeaderAvatar: "therapist-header-avatar",
  therapistHeaderDescription: "therapist-header-description",
  therapistHeaderTitle: "therapist-header-title",
  ...GroupClassTimeSlotTestID,
};
export {
  BookingStepTestID,
  BookingTestID,
  ChannelCardTestID,
  ConfirmationAlertTestID,
  ExploreTestID,
  FABTestID,
  FloatingButtonWrapperTestID,
  GroupClassRegistrationModalTestID,
  HomeTestID,
  LegalLinkTestID,
  LoginTestID,
  MessagesTestID,
  ModalTestID,
  NavTestID,
  OnboardingCalendarSyncTestID,
  OnboardingConsentTestID,
  OnboardingNotificationsTestID,
  OnboardingV2TestID,
  OnboardingVerifyInfoTestID,
  OnboardingWelcomeTestID,
  ProfileTestID,
  SafetyPlanTestID,
  ScheduleTestID,
  SMTTestID,
  TasksTestID,
  TextTestID,
  WeightTrackingTestID,
};
